import * as React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import "@fontsource/baloo-2";
import "@fontsource/baloo-2";
import "@fontsource/ibm-plex-sans";
import "@fontsource/ibm-plex-sans";
import { io } from "socket.io-client";

import "./App.css";
import ScreenSettingPage from "./components/Dashboard/ScreenSettingPage";
import LotterySystem from "./components/LotterySystem/LotterySystem";
import PendingPayment from "./components/ShopOwner/PendingPayment";
import {
  AdminTickets,
  ForgotPassword,
  Login,
  NotAuthorized,
  NotFound,
  ShopLotteryTickets,
  ShopOwner,
  SignUp,
  UserLotteryTickets,
} from "./pages";
import Setting from "./pages/Setting";

interface ProtectedRouteProps {
  children?: any;
  role?: Array<string>;
}

const App: React.FC = () => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const [auth, setAuth] = React.useState<any>({});

  // React.useEffect(() => {
  //   let localData = localStorage.getItem('UserData');
  //   console.log("Use effect calling");
  //   if(localData) {
  //     const userData = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;
  //     setAuth(userData);
  //   }

  //   return () => {
  //     setAuth({});
  //   }
  // }, [localStorage.getItem('UserData')]);

  // const socket = io(apiBaseURL, {
  //   autoConnect: false,
  //   query: {
  //     // 'userId': JSON.parse(localStorage.getItem('UserData') || "")?.uId
  //     'userId': 2
  //   }
  // });

  // React.useEffect(() => {

  //   if(!socket && !auth?.uId) return;

  //   socket.connect();

  //   return () => {
  //     console.log("Component unmount");
  //     socket.emit("preDisconnect", {
  //       userId: JSON.parse(localStorage.getItem('UserData') || "")?.uId
  //     });
  //     socket.disconnect();
  //   };
  // }, [socket]);

  const PrivateRoute = ({ children, role }: ProtectedRouteProps) => {
    const navigate = useNavigate();
    const localData: any =
      localStorage?.getItem("UserData") && JSON.parse(localStorage?.getItem("UserData") || "");
    if (!localData) {
      localStorage.clear();
      navigate("/login");
    }
    return localData ? (
      role?.includes(localData?.role) ? (
        children
      ) : (
        <Navigate to='/notAuthorized' />
      )
    ) : (
      <Navigate to='/login' />
    );
  };

  return (
    <div className='main'>
      <BrowserRouter>
        <Routes>
          <Route path='*' element={<NotFound />} />
          <Route path='/notAuthorized' element={<NotAuthorized />} />
          <Route path='/login' element={<Login />} />
          <Route path='/forgotPassword' element={<ForgotPassword />} />
          <Route path='/signUp' element={<SignUp />} />
          <Route
            path='/lottery'
            element={
              <PrivateRoute role={["SHOPOWNER"]}>
                <UserLotteryTickets />
              </PrivateRoute>
            }
          />
          <Route
            path='/shop/lottery'
            element={
              <PrivateRoute role={["SHOPOWNER"]}>
                <ShopLotteryTickets />
              </PrivateRoute>
            }
          />
          <Route path='/' element={<LotterySystem />} />
          <Route
            path='/setting/:id?'
            element={
              <PrivateRoute role={["ADMIN", "SHOPOWNER"]}>
                <Setting />
              </PrivateRoute>
            }
          />
          <Route
            path='/selection'
            element={
              <PrivateRoute role={["ADMIN", "SHOPOWNER"]}>
                <ScreenSettingPage />
              </PrivateRoute>
            }
          />
          <Route
            path='/pendingPayment'
            element={
              <PrivateRoute role={["SHOPOWNER"]}>
                <PendingPayment />
              </PrivateRoute>
            }
          />
          <Route
            path='/shopOwner/*'
            element={
              <PrivateRoute role={["SHOPOWNER"]}>
                <ShopOwner />
              </PrivateRoute>
            }
          />
          {/* <Route
          path="/shopOwner/*"
          element={
            <PrivateRoute role={["SHOPOWNER"]}>
                <ShopOwner socket={socket}/>
              </PrivateRoute>
          }
          /> */}
          <Route
            path='/admin/*'
            element={
              <PrivateRoute role={["ADMIN"]}>
                <AdminTickets />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
